type AvatarProps = {
  initials: string;
  imageUrl?: string | null;
  size?: number;
  tone?: 'primary' | 'accent';
  className?: string;
};

export function Avatar({ initials, imageUrl, size = 38, tone = 'accent', className = '' }: AvatarProps) {
  const toneClass = tone === 'primary' ? 'bg-action-primary' : 'bg-ai-accent';

  if (imageUrl) {
    return (
      <img
        src={imageUrl}
        alt=""
        className={`shrink-0 rounded-full object-cover ${className}`}
        style={{ width: size, height: size }}
      />
    );
  }

  return (
    <span
      className={`flex shrink-0 items-center justify-center rounded-full font-semibold text-text-inverse ${toneClass} ${className}`}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.32) }}
    >
      {initials}
    </span>
  );
}
